import { zusToast, type ZusToastPosition } from '@zep/toast';

import { ZepQuizApiError } from '@/api/httpClient';
import { type NamespacedTranslationKey } from '@/types/translation';

// 서버(zep-quiz-spring-server) commit 98045d36 에서 신설한 ErrorCode.
// 잠긴(유료 플랜 필요) 퀴즈셋을 학급에 연결하려고 할 때 4xx 와 함께 반환.
const CLASSROOM_LINK_ERROR_CODE = {
  QUIZSET_LOCKED: 'CLASS_LINK_QUIZSET_LOCKED',
} as const;

// 값 타입을 NamespacedTranslationKey 로 고정 → 시트에서 키가 사라지면 tsc 가 잡는다.
const ERROR_MESSAGE_KEYS: Record<string, NamespacedTranslationKey> = {
  [CLASSROOM_LINK_ERROR_CODE.QUIZSET_LOCKED]:
    'common:classroomLink.error.quizsetLocked',
};

/**
 * 기본 위치는 rht `<Toaster position="top-right">` 시절 자리를 보존한다(ZusToaster 기본은
 * bottom-center). 클래스 연결 창처럼 결과 토스트를 모두 아래 가운데에 두는 곳은
 * `position` 을 넘긴다.
 */
export function handleClassroomLinkError(
  error: unknown,
  translate: (key: NamespacedTranslationKey) => string,
  position: ZusToastPosition = 'top-right',
): boolean {
  if (!(error instanceof ZepQuizApiError)) return false;

  const key = ERROR_MESSAGE_KEYS[error.status];
  if (!key) return false;

  zusToast.error(translate(key), { position });
  return true;
}
